import "react";
import { jsx as e } from "react/jsx-runtime";
var t = {
	button: "_button_gah2u_1",
	primary: "_primary_gah2u_11",
	default: "_default_gah2u_18",
	secondary: "_secondary_gah2u_31",
	"secondary-new": "_secondary-new_gah2u_45",
	action: "_action_gah2u_55",
	drifting: "_drifting_gah2u_60",
	shortening: "_shortening_gah2u_64",
	oval: "_oval_gah2u_68",
	square: "_square_gah2u_71",
	round: "_round_gah2u_74",
	toggle: "_toggle_gah2u_77",
	"no-padding": "_no-padding_gah2u_86"
};
//#endregion
//#region primitives/button/button.tsx
function n({ borderColor: n, children: r, className: i, disabled: a, height: o, noPadding: s, onClick: c, regressionTag: l, shape: u, style: d, testId: f, type: p = "", width: m, ...h }) {
	u === "square" && !o && !m && console.warn("A height and width should be provided for a square button");
	let g = {
		...d,
		borderColor: n,
		height: o,
		width: m
	};
	return /* @__PURE__ */ e("button", {
		className: [
			t.button,
			t[p] || "",
			u ? t[u] : "",
			i || "",
			s ? t.noPadding : ""
		].join(" "),
		"data-regression-tag": l,
		"data-testid": f,
		disabled: a,
		onClick: c,
		style: g,
		...h,
		children: r
	});
}
//#endregion
//#region primitives/button/index.ts
var r = n;
//#endregion
export { r as default };
